import React, { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
    isValid: boolean;
    children?: ReactNode;
    userId: string;
}

const ProtectedRoute: FC<ProtectedRouteProps> = ({ isValid, children }) => {
    return isValid ? <>{children}</> : <Navigate to="/collections" replace />;
};

export default ProtectedRoute;
